module.exports = __webpack_public_path__ + "media/images/menu/pluto-0be45bfcb8c6dd05b2536b7da92eabf2.jpg";